import util from "../util";
import constants from "../constants";
import designService from "../service/designService";
import store from "../store";
import * as actions from "../actions";
import $ from "jquery";

function getMenuObjectFonts($mo) {
  const fonts = new Set();

  $mo.find('.config').each(function () {
    const config = $(this).text();
    const { styles } = JSON.parse(config);
    if (styles.name && styles.name['font-family']) fonts.add(styles.name['font-family']);
    if (styles.description && styles.description['font-family']) fonts.add(styles.description['font-family']);
    if (styles.price && styles.price['font-family']) fonts.add(styles.price['font-family']);
    if (styles.exstras && styles.exstras['font-family']) fonts.add(styles.exstras['font-family']);
  });

  return Array.from(fonts);
}

function getComponentFonts($component) {
  const fonts = new Set();

  $component.find('[data-component="text"]').find('p').each(function () {
    fonts.add(util.cleanFont($(this).css('fontFamily')));
  });

  return Array.from(fonts);
}

export function adjustFontSize($comp) {
  const size = parseInt($comp.attr('data-font-size'), 10);
  const dims = util.getActiveDimensions();
  let percent = 0;

  if (dims.unit === 'in') {
    const pixels = util.getPointsInPixels(size, dims);
    percent = util.pixelToPercent(pixels, dims.fontSize);
  } else {
    percent = size * constants.PIXEL_FONT_SIZE_ADJUSTMENT;
  }

  $comp.css('fontSize', `${percent}%`);
}

export function adjustColor($comp, fontColor) {
  $comp.css('color', fontColor);
  $('.color-box').css('background-color', fontColor);
  /*if (isLightBG) {
    $comp.css('color', 'rgb(0, 0, 0)');
    $('.color-box').css('background-color', 'rgb(0, 0, 0)');
  } else {
    $comp.css('color', 'rgb(255, 255, 255)');
    $('.color-box').css('background-color', 'rgb(255, 255, 255)');
  }*/
}

export function getDesignFonts() {
  const $pages = $('#pages');
  const fonts = new Set(getComponentFonts($pages));
  $pages.find('.menu-object').each(function () {
    getMenuObjectFonts($(this)).forEach((it) => fonts.add(it));
  });
  return Array.from(fonts);
}

export function updateActiveFonts () {
  const fonts = getDesignFonts()
    .map((label) => {
      const font = util.getFontByLabel(label);
      return font ? font.key : null
    })
    .filter((key) => !!key);
  designService.updateDesignFonts(store.getState().designId, fonts.join(','));
  store.dispatch(actions.updateDesignFonts(fonts));
}
